import { render, staticRenderFns } from "./document-fix-dialog.vue?vue&type=template&id=22785de0&"
import script from "./document-fix-dialog.vue?vue&type=script&lang=js&"
export * from "./document-fix-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports